<app-autocomplete class="autocomplete" [compactMode]="true" [fetch]="fetchProducts" [appearance]="'fill'" [stretch]="true" [dense]="true"
    [hideSubscript]="true" [showLabel]="false" [floatLabel]="'never'" (selected)="onProductSelected($event)" (enter)="onEnterTerm($event)">
</app-autocomplete>